import { render, staticRenderFns } from "./Schedules.vue?vue&type=template&id=6008c44f&scoped=true"
import script from "./Schedules.vue?vue&type=script&lang=js"
export * from "./Schedules.vue?vue&type=script&lang=js"
import style0 from "./Schedules.vue?vue&type=style&index=0&id=6008c44f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6008c44f",
  null
  
)

export default component.exports